import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای درخواست و تأیید مرخصی

این صفحه امکان ثبت و بررسی وضعیت درخواست‌های مرخصی اپراتورها در خطوط تولید را فراهم می‌کند.

## ۱. ثبت درخواست مرخصی جدید
سرپرست شیفت یا مسئول برنامه‌ریزی می‌تواند مرخصی پرسنل را به کمک فرم بالای صفحه ثبت کند.
برای ثبت درخواست:

- **شناسه اپراتور:** اپراتور مورد نظر را از لیست انتخاب کنید.
- **نوع مرخصی:** نوع آن (استحقاقی، استعلاجی، بدون حقوق و ...) را مشخص کنید. توجه داشته باشید که مدیریت این انواع از طریق دکمه‌ی «⚙️ مدیریت انواع مرخصی» در بالای همین صفحه امکان‌پذیر است.
- **زمان شروع و پایان:** با استفاده از تقویم، تاریخ و ساعت دقیق شروع و پایان مرخصی را درج کنید (قابلیت ثبت مرخصی روزانه و ساعتی وجود دارد).
- **دلیل:** در صورت نیاز توضیحی برای مرخصی ثبت نمایید.

## ۲. مدیریت انواع مرخصی
با کلیک بر روی دکمه‌ی «⚙️ مدیریت انواع مرخصی» در بالای صفحه، به تنظیمات این بخش هدایت می‌شوید. در آنجا می‌توانید:
- انواع مرخصی‌های سازمان را تعریف کنید (مانند مرخصی استحقاقی، مرخصی تحصیلی، مرخصی استعلاجی و ...).
- تعیین کنید که آیا یک نوع مرخصی **با حقوق (Paid)** است یا خیر.
- تعیین کنید که آیا این مرخصی می‌تواند به صورت **ساعتی** درخواست شود یا منحصراً روزانه است.

## ۳. بررسی و تأیید درخواست‌ها
در جدول پایین صفحه، لیست تمامی درخواست‌های مرخصی ثبت شده، نمایش داده می‌شود. وضعیت اولیه تمامی درخواست‌ها «در انتظار (Pending)» است.
افراد دارای دسترسی می‌توانند از ستون عملیات، وضعیت درخواست را با دکمه‌های مربوطه به **«تأیید شده (Approved)»** یا **«رد شده (Rejected)»** تغییر دهند.

تأیید یک مرخصی باعث می‌شود سیستم در محاسبه شیفت‌های مؤثر روزانه‌ی اپراتور، آن بازه زمانی را به عنوان مرخصی در نظر بگیرد.


export default Layout;
